import api from './';

export default {
  apiGetUserInfo: params => api.get('xxxx', { params }),
  apiAddProduct: params => api.post('xxx', params),
};



// WEBPACK FOOTER //
// ./src/api/home.js